import { api, apiEnabled } from './api.js';

// ── Favorites ───────────────────────────────────────────────────────────────
export async function fetchFavorites() {
  if (!apiEnabled) return [];
  try {
    const data = await api('/api/favorites');
    return data?.items ?? [];
  } catch { return []; }
}

export async function addFavorite(propertyId) {
  if (!apiEnabled) return;
  try { await api('/api/favorites', { method: 'POST', body: JSON.stringify({ propertyId }) }); } catch {}
}

export async function removeFavorite(propertyId) {
  if (!apiEnabled) return;
  try { await api(`/api/favorites/${propertyId}`, { method: 'DELETE' }); } catch {}
}

// ── Saved Filters / Alerts ──────────────────────────────────────────────────
export async function fetchSavedFilters() {
  if (!apiEnabled) return [];
  try {
    const data = await api('/api/saved-filters');
    return data?.items ?? [];
  } catch { return []; }
}

export async function createSavedFilter(payload) {
  if (!apiEnabled) return null;
  try {
    const data = await api('/api/saved-filters', { method: 'POST', body: JSON.stringify(payload) });
    return data?.item ?? null;
  } catch { return null; }
}

export async function deleteSavedFilter(id) {
  if (!apiEnabled) return;
  try { await api(`/api/saved-filters/${id}`, { method: 'DELETE' }); } catch {}
}
